/**
 * Ejecuta `fn` sobre cada elemento con un tope de tareas en paralelo.
 *
 * Se usa en los procesos masivos (exportar planillas, verificación automática de una línea) para no
 * disparar cientos de peticiones simultáneas al backend.
 */
export const runWithConcurrency = async <T, R>(
  items: T[],
  fn: (item: T) => Promise<R>,
  concurrency: number
): Promise<R[]> => {
  const results: R[] = new Array(items.length);
  let nextIdx = 0;

  const worker = async () => {
    while (nextIdx < items.length) {
      const i = nextIdx++;
      results[i] = await fn(items[i]);
    }
  };

  await Promise.all(Array.from({ length: Math.min(concurrency, items.length) }, worker));
  return results;
};
